(function () {
  var style = document.createElement('style');
  style.textContent =
    '.lr-link{display:inline-flex!important;overflow:hidden;-webkit-transition:none!important;transition:none!important;text-rendering:optimizeSpeed;}' +
    '.lr-line{display:flex!important;overflow:hidden;pointer-events:none;}' +
    '.lr-word{position:relative;display:inline-flex;overflow:hidden;}' +
    '.lr-word+.lr-word::before{content:"\\00a0";}' +
    '.lr-char{position:relative;top:0;display:inline-block;' +
      '-webkit-transition:top .45s cubic-bezier(.455,.03,.515,.955) calc(var(--char-index)*30ms);' +
      'transition:top .45s cubic-bezier(.455,.03,.515,.955) calc(var(--char-index)*30ms);}' +
    '.lr-char::before{content:attr(data-char);position:absolute;top:100%;left:0;}' +
    '.lr-active .lr-char{top:-100%;}';
  document.head.appendChild(style);

  function initEl(el) {
    if (el.dataset.lrInit) return;
    el.dataset.lrInit = '1';
    el.classList.add('lr-link');
    var target = el.querySelector('b') || el;
    var text = target.textContent.trim();
    var line = document.createElement('div');
    line.className = 'lr-line';
    var charIdx = 0;
    text.split(' ').filter(function (w) { return w.length > 0; }).forEach(function (word) {
      var wordEl = document.createElement('div');
      wordEl.className = 'lr-word';
      word.split('').forEach(function (char) {
        var charEl = document.createElement('div');
        charEl.className = 'lr-char';
        charEl.style.setProperty('--char-index', charIdx++);
        charEl.dataset.char = char;
        charEl.textContent = char;
        wordEl.appendChild(charEl);
      });
      line.appendChild(wordEl);
    });
    target.textContent = '';
    target.appendChild(line);
    el.addEventListener('mouseenter', function () { el.classList.add('lr-active'); });
    el.addEventListener('mouseleave', function () { el.classList.remove('lr-active'); });
  }

  function LetterRollEffect(opts) {
    var sels = [].concat(opts.elements || []);
    function run() {
      sels.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(initEl);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }
  window.LetterRollEffect = LetterRollEffect;
})();
